import { webKnots } from '../../../../common/back/lace/webKnots'
import { jointOfCatchFace, jointOfIndexFinger, jointOfThumbFinger2 } from './parts/earJointParts'
import { topSidePartOfWebForPicher } from './parts/sideParts'

export const type3Web = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfIndexFinger(ctx, webColor, laceColor, 3, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -24, 90)
  jointOfIndexFinger(ctx, webColor, laceColor, -45, 160)
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56)
  jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30)
  jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
  ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
  ctx.fill()
  ctx.moveTo(532, 111) // 左上
  ctx.quadraticCurveTo(550, 145, 550, 145) // 左下
  ctx.quadraticCurveTo(532, 137, 526, 156) //
  ctx.quadraticCurveTo(490, 225, 569, 317) // 左下
  ctx.quadraticCurveTo(520, 300, 484, 240) // 左下
  ctx.moveTo(679, 288) // 右上
  ctx.quadraticCurveTo(659, 205, 620, 172) // 左下
  ctx.quadraticCurveTo(598, 165, 592, 190) // 右上
  ctx.quadraticCurveTo(585, 211, 600, 234) // 右上
  ctx.quadraticCurveTo(597, 205, 604, 200) // 右上
  ctx.quadraticCurveTo(617, 188, 633, 220) // 右上
  ctx.quadraticCurveTo(649, 256, 647, 312) // 右上
  ctx.moveTo(581, 110) // 右上
  ctx.quadraticCurveTo(556, 161, 552, 196) // 左下
  ctx.quadraticCurveTo(542, 184, 545, 169) // 左上
  ctx.quadraticCurveTo(532, 165, 532, 165) // 左上
  ctx.quadraticCurveTo(526, 183, 526, 183) // 左下
  ctx.quadraticCurveTo(550, 244, 550, 244) // 右下
  ctx.quadraticCurveTo(548, 255, 548, 255) //
  ctx.quadraticCurveTo(559, 257, 559, 257) //
  ctx.quadraticCurveTo(573, 294, 600, 316) //
  ctx.quadraticCurveTo(575, 276, 573, 258) //
  ctx.quadraticCurveTo(607, 273, 617, 300) //
  ctx.quadraticCurveTo(633, 303, 633, 303) //
  ctx.quadraticCurveTo(639, 290, 639, 290) //
  ctx.quadraticCurveTo(632, 272, 632, 272) //
  ctx.quadraticCurveTo(626, 282, 571, 239) //
  ctx.quadraticCurveTo(566, 194, 582, 149) //
  ctx.quadraticCurveTo(575, 162, 568, 175) //
  ctx.quadraticCurveTo(564, 158, 581, 110) //
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 87) // 左上
  ctx.quadraticCurveTo(508, 166, 486, 252) // 左下
  ctx.quadraticCurveTo(505, 318, 581, 358) // 右下
  ctx.quadraticCurveTo(630, 326, 689, 277) //
  // 内側
  ctx.moveTo(555, 87) // 左上
  ctx.quadraticCurveTo(539, 117, 539, 117) // 左下
  ctx.quadraticCurveTo(549, 128, 555, 150) //
  ctx.quadraticCurveTo(534, 138, 529, 158) //
  ctx.quadraticCurveTo(495, 225, 577, 322) //
  ctx.quadraticCurveTo(525, 310, 491, 256) //
  ctx.quadraticCurveTo(515, 321, 582, 354) //
  ctx.quadraticCurveTo(620, 327, 643, 310) //
  ctx.quadraticCurveTo(649, 247, 619, 204) //
  ctx.quadraticCurveTo(599, 187, 603, 238) //
  ctx.quadraticCurveTo(572, 210, 597, 173) //
  ctx.quadraticCurveTo(614, 160, 629, 177) //
  ctx.quadraticCurveTo(660, 205, 681, 280) //
  ctx.quadraticCurveTo(688, 271, 688, 271) //
  ctx.quadraticCurveTo(652, 145, 554, 87) //
  // 内側
  ctx.moveTo(581, 105) // 左上
  ctx.quadraticCurveTo(560, 141, 550, 189) // 左下
  ctx.quadraticCurveTo(547, 178, 549, 167) //
  ctx.quadraticCurveTo(530, 160, 530, 162) //
  ctx.quadraticCurveTo(523, 182, 523, 182) //
  ctx.quadraticCurveTo(546, 243, 546, 243) //
  ctx.quadraticCurveTo(545, 257, 545, 257) //
  ctx.quadraticCurveTo(558, 260, 558, 260) //
  ctx.quadraticCurveTo(567, 298, 605, 322) //
  ctx.quadraticCurveTo(580, 279, 576, 261) //
  ctx.quadraticCurveTo(607, 280, 615, 302) //
  ctx.quadraticCurveTo(635, 306, 635, 306) //
  ctx.quadraticCurveTo(642, 290, 642, 290) //
  ctx.quadraticCurveTo(632, 267, 632, 267) //
  ctx.quadraticCurveTo(626, 280, 574, 237) //
  ctx.quadraticCurveTo(570, 190, 587, 139) //
  ctx.quadraticCurveTo(571, 164, 571, 165) //
  ctx.quadraticCurveTo(571, 146, 585, 107) //
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目
}

export const type3WebLeftThrow = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  // web先端の革パーツ
  topSidePartOfWebForPicher(ctx, webColor, laceColor, stitchColor)
  // ウェブ-人差し指のジョイントパーツ
  jointOfIndexFinger(ctx, webColor, laceColor, 3, 30)
  jointOfIndexFinger(ctx, webColor, laceColor, -24, 90)
  jointOfIndexFinger(ctx, webColor, laceColor, -45, 160)
  jointOfCatchFace(ctx, webColor, laceColor, -10, 12)
  jointOfCatchFace(ctx, webColor, laceColor, 38, 57)
  jointOfThumbFinger2(ctx, webColor, laceColor, 53, -56)
  jointOfThumbFinger2(ctx, webColor, laceColor, 19, -30)
  jointOfThumbFinger2(ctx, webColor, laceColor, -18, -5)
  // web本体のflatパーツ
  ctx.fillStyle = webColor
  ctx.beginPath()
  ctx.moveTo(549, 81) // 左上
  ctx.quadraticCurveTo(502, 166, 482, 247) // 左下1
  ctx.quadraticCurveTo(480, 256, 486, 268) // 左下2
  ctx.quadraticCurveTo(516, 326, 565, 357) // 右下1
  ctx.quadraticCurveTo(571, 362, 582, 362) // 右下2
  ctx.quadraticCurveTo(637, 324, 693, 280) // 右上
  ctx.quadraticCurveTo(660, 140, 549, 81) // 左上
  ctx.fill()
  // 左上の三日月みたいな部分
  ctx.moveTo(539, 95) // 左上
  ctx.quadraticCurveTo(645, 135, 655, 220) // 右下
  ctx.quadraticCurveTo(630, 159, 585, 145) // 左下手前
  ctx.quadraticCurveTo(553, 137, 526, 147) //
  ctx.quadraticCurveTo(520, 160, 520, 160) //
  ctx.quadraticCurveTo(516, 173, 535, 190) //
  ctx.quadraticCurveTo(510, 178, 510, 178) //
  ctx.stroke()
  ctx.closePath()

  // 中央の「大」みたいな部分
  ctx.beginPath()
  ctx.moveTo(608, 163)
  ctx.quadraticCurveTo(592, 167, 592, 167) //
  ctx.quadraticCurveTo(538, 150, 538, 150) //
  ctx.quadraticCurveTo(530, 162, 530, 162) //
  ctx.quadraticCurveTo(540, 175, 540, 175) //
  ctx.quadraticCurveTo(545, 174, 566, 179) //
  ctx.quadraticCurveTo(515, 212, 505, 250)
  ctx.quadraticCurveTo(532, 217, 564, 200) //
  ctx.quadraticCurveTo(545, 223, 548, 223) //
  ctx.quadraticCurveTo(576, 200, 597, 200)
  ctx.quadraticCurveTo(618, 234, 624, 264)
  ctx.quadraticCurveTo(625, 276, 611, 284) //
  ctx.quadraticCurveTo(622, 289, 626, 307) //
  ctx.quadraticCurveTo(639, 301, 639, 301) //
  ctx.quadraticCurveTo(645, 290, 643, 274) //
  ctx.quadraticCurveTo(629, 244, 617, 210) //
  ctx.quadraticCurveTo(648, 231, 654, 235) //
  ctx.quadraticCurveTo(627, 193, 615, 184) //
  ctx.quadraticCurveTo(608, 163, 608, 163) //
  ctx.stroke()
  ctx.closePath()

  // 右下のうずまきみたいな部分
  // 中央の「大」みたいな部分
  ctx.beginPath()
  ctx.moveTo(628, 325) // 右上
  ctx.quadraticCurveTo(565, 318, 560, 282) //
  ctx.quadraticCurveTo(563, 254, 597, 260) //
  ctx.quadraticCurveTo(563, 240, 543, 265) //
  ctx.quadraticCurveTo(529, 293, 574, 350) //
  ctx.stroke()
  ctx.closePath()

  // stitchここから
  ctx.beginPath()
  ctx.strokeStyle = stitchColor
  ctx.setLineDash([3, 3])
  // 外側
  ctx.moveTo(552, 86) // 左上
  ctx.quadraticCurveTo(505, 171, 487, 250) // 左下
  ctx.quadraticCurveTo(500, 306, 577, 359) // 右下
  ctx.quadraticCurveTo(636, 319, 690, 279) // 右上
  ctx.quadraticCurveTo(655, 135, 546, 86) //

  // 内側
  ctx.moveTo(553, 93) // 左上
  ctx.quadraticCurveTo(549, 96, 549, 96) //
  ctx.quadraticCurveTo(582, 106, 622, 143) //
  ctx.quadraticCurveTo(656, 180, 657, 229) //
  ctx.quadraticCurveTo(624, 158, 588, 150) //
  ctx.quadraticCurveTo(546, 138, 526, 152) //
  ctx.quadraticCurveTo(513, 170, 539, 194) //
  ctx.quadraticCurveTo(511, 184, 511, 184) //
  ctx.quadraticCurveTo(498, 213, 490, 252) //
  ctx.quadraticCurveTo(524, 325, 577, 353) //
  ctx.quadraticCurveTo(533, 316, 537, 270) //
  ctx.quadraticCurveTo(554, 232, 604, 262) //
  ctx.quadraticCurveTo(570, 257, 564, 277) //
  ctx.quadraticCurveTo(564, 315, 626, 320) //
  ctx.quadraticCurveTo(695, 270, 695, 270) //

  // 中央の「大」みたいな部分
  ctx.moveTo(605, 160) // 上
  ctx.quadraticCurveTo(585, 163, 587, 162) //
  ctx.quadraticCurveTo(534, 146, 534, 146) //
  ctx.quadraticCurveTo(527, 161, 527, 161) //
  ctx.quadraticCurveTo(537, 178, 537, 178) //
  ctx.quadraticCurveTo(557, 180, 557, 180) //
  ctx.quadraticCurveTo(506, 213, 502, 258) //
  ctx.quadraticCurveTo(528, 223, 557, 207) //
  ctx.quadraticCurveTo(542, 223, 544, 229) //
  ctx.quadraticCurveTo(570, 210, 595, 203) //
  ctx.quadraticCurveTo(627, 266, 618, 272) //
  ctx.quadraticCurveTo(624, 275, 605, 284) //
  ctx.quadraticCurveTo(614, 283, 624, 312) //
  ctx.quadraticCurveTo(653, 304, 648, 274) //
  ctx.quadraticCurveTo(622, 215, 622, 215) //
  ctx.quadraticCurveTo(658, 240, 658, 240) //
  ctx.quadraticCurveTo(624, 183, 618, 184) //
  ctx.quadraticCurveTo(610, 160, 610, 160) //
  ctx.stroke()
  ctx.setLineDash([])
  ctx.strokeStyle = laceColor
  ctx.closePath()
  // stitchここまで
  webKnots(ctx, laceColor, -110, 110, 1) // ウェブ先端寄りのウェブ結び目
}
